import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TermCategoryRow } from '@models/term/termCategory';
import { Link } from '@router/Link';
import { useTranslation } from 'react-i18next';

interface Props {
    termCategory: TermCategoryRow;
}

function PolicyRow({ termCategory }: Props) {
    const { t } = useTranslation('accountSetting');
    const { title, id } = termCategory;
    return (
        <Container fullWidth justify='space-between' align='center'>
            <Text size='lg' color={colors.gray7}>{title}</Text>
            <Link activityName='TermDetailActivity'
                activityParams={{ termCategoryId: id }} >
                <Text color={colors.primary}
                    fontWeight='medium'
                    css={linkCss}>
                    {t('policies.view')}
                </Text>
            </Link>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 8px 0;
`;

const linkCss = css`
    text-decoration: underline;
    text-underline-offset: 2px;
`;

export default PolicyRow;
